<header class="top-nav">
  <div class="nav-left">
    <div class="logo">
      <img src="assets/smata-shared/netstrata-tenant-logo.svg" alt="logo" />
      <smata-environment-badge></smata-environment-badge>
    </div>
  </div>
  <div class="nav-right">
    <smata-menu-profile
      [userDisplayName]="userDisplayName()"
      (logout)="handleUserLogout()"
    ></smata-menu-profile>
  </div>
</header>
